import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';

import './AppointmentOrderDetail.less';

import { TopNav } from 'src/common/top-nav/TopNav';

export default class AppointmentOrderDetail extends OfficialPage {
  state = {
    orderData: {},
    orderInfo: {},
    orderStatus: {
      '0': '待付款',
      '1': '待商家确认',
      '2': '待消费',
      '3': '待评价',
      '4': '退款审核中',
      '5': '退款中',
      '6': '已消费',
      '7': '已关闭'
    },
    selectAddressId: '',
    goodsAdditionalInfo: {},
    hasAdditionalInfo: false,
    customFields: [],
    orderId: '',
    isFromTemplateMsg: false,
    originalPrice: '',
    useBalance: '',
    freightAdress: {},
    express_fee: '',
    discount_cut_price: '',
    isFromBack: false
  }

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false,
      franchiseeId: options.franchisee || ''
    })
    this.dataInitial()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      if (!!this.data.orderInfo.order_id) {
        this.getOrderDetail(this.data.orderInfo.order_id)
      }
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  dataInitial = () => {
    this.getOrderDetail(this.data.orderId)
    this.initialAddressId()
  }
  getOrderDetail = orderId => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: orderId,
        sub_shop_app_id: this.data.franchiseeId
      },
      success: function (res) {
        var data = res.data[0],
          form_data = data.form_data,
          hasAdditionalInfo = false,
          start_date = form_data.appointment_order_info.appointment_start_date,
          end_date = form_data.appointment_order_info.appointment_end_date,
          additional_info_goods = [],
          additional_goodsid_arr = [],
          address_id = ''
        for (var i = 0; i < form_data.goods_info.length; i++) {
          var deliveryId = form_data.goods_info[i].delivery_id,
            goodsId = form_data.goods_info[i].id
          if (
            deliveryId &&
            deliveryId != '0' &&
            additional_goodsid_arr.indexOf(goodsId) == -1
          ) {
            additional_info_goods.push(form_data.goods_info[i])
            additional_goodsid_arr.push(goodsId)
            hasAdditionalInfo = true
          }
        }
        form_data.remark = form_data.remark
          ? form_data.remark.replace(/\n|\\n/g, '\n')
          : form_data.remark
        if (start_date && end_date) {
          if (start_date.substring(0, 4) == end_date.substring(0, 4)) {
            form_data.appointment_order_info.appointment_start_date =
              start_date.substring(4, 6) + '-' + start_date.substring(6)
            form_data.appointment_order_info.appointment_end_date =
              end_date.substring(4, 6) + '-' + end_date.substring(6)
          } else {
            form_data.appointment_order_info.appointment_start_date =
              start_date.substring(0, 4) +
              '-' +
              start_date.substring(4, 6) +
              '-' +
              start_date.substring(6)
            form_data.appointment_order_info.appointment_end_date =
              end_date.substring(0, 4) +
              '-' +
              end_date.substring(4, 6) +
              '-' +
              end_date.substring(6)
          }
        }
        if (form_data.appointment_order_info.appointment_unit_type == '6') {
          form_data.timeDiff =
            Date.parse(new Date()) -
              Date.parse(new Date(form_data.appointment_time.split('~')[1])) >
              0
              ? true
              : false
        } else {
          form_data.timeDiff = false
        }
        that.setData({
          orderData: data,
          orderInfo: form_data,
          hasAdditionalInfo: hasAdditionalInfo,
          appointment_interval:
            form_data.appointment_order_info.appointment_interval &&
              form_data.appointment_order_info.appointment_interval.substring(
                6,
                8
              ) >= 24
              ? form_data.appointment_order_info.appointment_interval.substring(
                0,
                6
              ) +
              '次日' +
              (form_data.appointment_order_info.appointment_interval.substring(
                6,
                8
              ) *
                1 -
                24) +
              form_data.appointment_order_info.appointment_interval.substring(
                8
              )
              : form_data.appointment_order_info.appointment_interval,
          discount_cut_price: form_data.discount_cut_price,
          useBalance: Number(form_data['use_balance']),
          express_fee: res.data[0]['express_fee']
        })
        app.setPreviewGoodsInfo(additional_info_goods)
        app.setGoodsAdditionalInfo(form_data.additional_info || {})
      }
    })
  }
  orderDelete = e => {
    var orderId = this.data.orderId,
      that = this,
      franchiseeId = this.data.franchiseeId
    app.showModal({
      content: '订单删除后不可找回，确认删除？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/HideOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: franchiseeId
          },
          success: function (res) {
            app.turnBack()
          }
        })
      }
    })
  }
  cancelOrder = e => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '是否取消订单？',
      showCancel: true,
      confirmText: '是',
      cancelText: '否',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 7
            that.setData(data)
          }
        })
      }
    })
  }
  payOrder = e => {
    var address_info = this.data.orderInfo.address_info,
      that = this,
      orderId
    orderId = this.data.orderInfo.order_id
    if (this.data.orderInfo.total_price == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          setTimeout(function () {
            app.showToast({
              title: '支付成功',
              icon: 'success',
              success: function () {
                that.paySuccessCallback()
              }
            })
          })
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data,
    //       orderId = that.data.orderInfo.order_id
    //     param.orderId = orderId
    //     param.goodsType = that.data.orderInfo.goods_type
    //     param.success = function () {
    //       that.paySuccessCallback()
    //     }
    //     app.wxPay(param)
    //   }
    // })
    let pagePath = '/goodsOrderPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '') + '&code=code';
    app.goPay({
      orderId: orderId,
      successUrl : pagePath
    });
  }
  applyDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定要申请退款？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/applyRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 4
            that.setData(data)
          }
        })
      }
    })
  }
  receiveDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定已收到退款？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 7
            that.setData(data)
          }
        })
      }
    })
  }
  checkLogistics = () => {
    var orderId = this.data.orderInfo.order_id
    app.turnToPage(
      '/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId
    )
  }
  sureReceipt = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '确定已消费？',
      showCancel: true,
      confirmText: '确定',
      cancelText: '取消',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/comfirmOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 3
            that.setData(data)
          }
        })
      }
    })
  }
  makeComment = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/makeComment/makeComment?detail=' +
        this.data.orderInfo.order_id +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  showAddressList = () => {
    var addressId = this.data.selectAddressId,
      orderId = this.data.orderInfo.order_id,
      franchiseeId = this.data.franchiseeId
    app.turnToPage(
      '/eCommerce/pages/myAddress/myAddress?id=' +
      addressId +
      '&oid=' +
      orderId +
      '&sub_shop_id=' +
      franchiseeId,
      true
    )
  }
  showAddAddress = () => {
    var orderId = this.data.orderInfo.order_id
    var _this = this
    if (app.chooseAddress) {
      app.chooseAddress({
        success: function (res) {
          app.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || '',
              order_id: orderId
            },
            success: function () {
              _this.dataInitial()
            }
          })
        }
      })
    } else {
      var orderId = this.data.orderInfo.order_id
      app.turnToPage('/eCommerce/pages/addAddress/addAddress?oid=' + orderId)
    }
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  verificationCode = () => {
    app.turnToPage(
      '/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' +
      this.data.orderInfo.order_id +
      '&sub_shop_app_id=' +
      this.data.franchiseeId
    )
  }
  getFreigtAdress = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppShopLocationInfo',
      data: {
        app_id: app.getAppId()
      },
      success: function (res) {
        that.setData({
          freightAdress: res.data
        })
      }
    })
  }
  freightGoMap = () => {
    var _this = this,
      infor =
        _this.data.freightAdress.region_string +
        _this.data.freightAdress.shop_location
    infor = infor.replace(/\s+/g, '')
    app.sendRequest({
      url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
      data: {
        location_info: infor
      },
      success: function (res) {
        if (res.result) {
          app.openLocation({
            latitude: res.result.location.lat,
            longitude: res.result.location.lng
          })
        }
      }
    })
  }
  initialAddressId = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/addressList',
      data: {
        app_id: app.getAppId()
      },
      success: function (res) {
        if (res.data.length) {
          that.setData({
            selectAddressId: res.data[0].id
          })
        }
      }
    })
  }
  freightPlayPhone = () => {
    var that = this
    app.makePhoneCall(that.data.freightAdress.shop_contact)
  }
  seeAdditionalInfo = () => {
    app.turnToPage(
      '/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail'
    )
  }
  paySuccessCallback = () => {
    let orderId = this.data.orderInfo.order_id
    let franchiseeId = this.data.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '') +
      '&code=code'
    if (!franchiseeId) {
      app.sendRequest({
        url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
        data: {
          order_id: orderId,
          sub_app_id: franchiseeId
        },
        success: function (res) {
          if (res.valid == 0) {
            pagePath += '&collectBenefit=1'
          }
          app.turnToPage(pagePath, 1)
        }
      })
    } else {
      app.turnToPage(pagePath, 1)
    }
  }

  render() {
    const {
      showGetUserInfo,
      isFromTemplateMsg,
      orderStatus,
      orderInfo,
      appointment_interval,
      discount_cut_price,
      useBalance,
      hasAdditionalInfo
    } = this.state

    return (
      <div className="official-page appointment-order-detail">
        <TopNav title="订单详情" />
        <div>
          {isFromTemplateMsg && (
            <div
              className="order-detail-section orderDetail-goto-homepage"
              onClick={this.goToHomepage}
              style={convertLineStyleData('margin-bottom:0;')}
            >
              <div className="ico-moon icon-rightarrow"></div>返回首页
            </div>
          )}
          <div className="order-detail-section top-section">
            <div style={convertLineStyleData('margin-bottom: 18rpx;')}>
              {'订单状态: ' + orderStatus[orderInfo.status]}
            </div>
            <div>{'订单号: ' + orderInfo.order_id}</div>
          </div>
          {+orderInfo.status === 0 && (
            <div
              className="order-detail-section"
              style={convertLineStyleData('border-top:1px solid #e8e8e8;')}
            >
              等待买家付款
            </div>
          )}
          {!(orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_user_phone) ? (
            <div className="order-detail-section">
              <div className="address-info-section">
                {orderInfo.is_self_delivery == 0 ||
                  !(orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_user_phone)? (
                    <React.Fragment>
                      <div style={convertLineStyleData('margin-bottom: 3px')}>
                        {orderInfo.address_info && (orderInfo.address_info.name +
                          ' ' +
                          orderInfo.address_info.contact)}
                      </div>
                      {(orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.need_user_address) !=
                        0 && (
                          <div>
                            {orderInfo && orderInfo.address_info && (orderInfo.address_info.province.text +
                              orderInfo.address_info.city.text +
                              orderInfo.address_info.district.text +
                              orderInfo.address_info.detailAddress)}
                          </div>
                        )}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <div style={convertLineStyleData('margin-bottom: 3px')}>
                        {orderInfo && orderInfo.appointment_order_info && (orderInfo.appointment_order_info.appointment_user_name +
                          ' ' +
                          orderInfo.appointment_order_info.appointment_user_phone)}
                      </div>
                    </React.Fragment>
                  )}
              </div>
            </div>
          ) : (
              <div className="order-detail-section">
                <div className="address-info-section">
                  {(orderInfo.is_self_delivery == 0 ||
                    !orderInfo.appointment_order_info.appointment_user_phone) && (
                      <React.Fragment>
                        <div style={convertLineStyleData('margin-bottom: 3px')}>
                          {orderInfo.appointment_order_info.appointment_user_name +
                            ' ' +
                            orderInfo.appointment_order_info.appointment_user_phone}
                        </div>
                      </React.Fragment>
                    )}
                </div>
              </div>
            )}
          <div
            className="order-detail-section"
            style={convertLineStyleData('margin-bottom: 0; padding-bottom: 0; border-bottom: none;')}
          >
            {orderInfo && orderInfo.goods_info && orderInfo.goods_info.map((goods, goodsIndex) => {
              return (
                <div className="goods-list-item" key={goods.id}>
                  <img className="goods-cover" src={goods.cover} />
                  {goods.is_seckill == 1 ? (
                    <React.Fragment>
                      <div className="goods-content goods-seckill-content">
                        <div>{goods.goods_name}</div>
                        {goods.model_value && (
                          <div className="goods-model">
                            {goods.model_value}
                          </div>
                        )}
                      </div>
                      <div className="goods-right goods-seckill-right">
                        <div>
                          <span className="goods-seckill-price">
                            {'¥' + goods.price}
                          </span>
                          <span className="goods-original-price">
                            {'¥' + goods.original_price}
                          </span>
                        </div>
                        <div className="goods-seckill-sign">秒杀商品</div>
                        <div style={convertLineStyleData('margin-top: 5px;')}>{'× ' + goods.num}</div>
                      </div>
                    </React.Fragment>
                  ) : (
                      <React.Fragment>
                        <div className="goods-content">
                          <div>{goods.goods_name}</div>
                          {goods.model_value && (
                            <div className="goods-model">
                              {goods.model_value}
                            </div>
                          )}
                          {goods.is_benefit_goods && (
                            <div className="gift-text">赠品</div>
                          )}
                        </div>
                        {!goods.is_benefit_goods && (
                          <div className="goods-right">
                            <div>{'¥' + goods.price}</div>
                            <div style={convertLineStyleData('margin-top: 5px;')}>
                              {'× ' + goods.num}
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    )}
                </div>
              )
            })}
          </div>
          {orderInfo && orderInfo.appointment_order_info && (orderInfo.appointment_order_info.appointment_unit_type == 3 ||
            orderInfo.appointment_order_info.appointment_unit_type == 6) ? (
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                起始日期
              <span className="pull-right">
                  {orderInfo.appointment_order_info.appointment_start_date}
                </span>
              </div>
            ) : (
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                预约日期
              <span className="pull-right">
                  {orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_day}
                </span>
              </div>
            )}
          {orderInfo && orderInfo.appointment_order_info && (orderInfo.appointment_order_info.appointment_unit_type == 3 ||
            orderInfo.appointment_order_info.appointment_unit_type == 6) ? (
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                结束日期
              <span className="pull-right">
                  {orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_end_date}
                </span>
              </div>
            ) : (
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                预约时段<span className="pull-right">{appointment_interval}</span>
              </div>
            )}
          {orderInfo && orderInfo.appointment_order_info && (orderInfo.appointment_order_info.appointment_unit_type == 3 ||
            orderInfo.appointment_order_info.appointment_unit_type == 6) ? (
              <div className="order-detail-section">
                预约时间
              <span className="pull-right">
                  {orderInfo.appointment_order_info.appointment_to_store_time}
                </span>
              </div>
            ) : (
              <div className="order-detail-section">
                服务时长
              <span className="pull-right">
                  {orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_time_long}
                </span>
              </div>
            )}
          {orderInfo.has_seckill == 1 ? (
            <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
              预约金额
              <span className="pull-right">
                {'¥' + orderInfo.seckill_original_price}
              </span>
            </div>
          ) : (
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                预约金额
              <span className="pull-right">
                  {'¥' + (orderInfo.original_price || '免费')}
                </span>
              </div>
            )}
          {orderInfo.has_seckill == 1 && (
            <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
              活动优惠
              <span className="pull-right">
                {'秒杀  - ¥' + orderInfo.seckill_cut_price}
              </span>
            </div>
          )}
          <div className="order-detail-section">
            优惠抵扣
            <span className="pull-right">{'- ¥' + discount_cut_price}</span>
          </div>
          {!!+orderInfo.total_integral &&
            orderInfo.total_integral != 0 &&
            orderInfo.total_integral != '0' && (
              <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
                订单积分
                <span className="pull-right">
                  {orderInfo.total_integral + '积分'}
                </span>
              </div>
            )}
          <div className="order-detail-section">
            订单总价
            <span className="pull-right">
              {'¥' +
                (orderInfo.original_price
                  ? orderInfo.order_total_price
                  : '免费')}
            </span>
          </div>
          {(orderInfo.status || orderInfo.coupon_fee) && (
            <div style={convertLineStyleData('margin-bottom: 0; border-top:1px solid #e8e8e8;')}></div>
          )}
          {orderInfo.status != 0 && (
            <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
              储值抵扣<span className="pull-right">{'- ¥' + useBalance}</span>
            </div>
          )}
          {!!+orderInfo.coupon_fee && (
            <div className="order-detail-section" style={convertLineStyleData('margin-bottom: 0;')}>
              社交立减金
              <span className="pull-right">{'- ¥' + orderInfo.coupon_fee}</span>
            </div>
          )}
          <div className="order-detail-section">
            需付款
            <span className="pull-right" style={convertLineStyleData('color: #ff7100;')}>
              {'¥' +
                (orderInfo.total_price != '0.00'
                  ? orderInfo.total_price
                  : '免费')}
            </span>
          </div>
          {!!+hasAdditionalInfo && (
            <div
              className="order-detail-section"
              onClick={this.seeAdditionalInfo}
              style={convertLineStyleData('border-top:1px solid #e8e8e8;')}
            >
              补充信息
              <div className="ico-moon icon-rightarrow pull-right"></div>
            </div>
          )}
          {orderInfo.remark && (
            <div
              className="order-detail-section"
              style={convertLineStyleData('border-top:1px solid #e8e8e8;')}
            >
              <div className="section-title">留言</div>
              <div className="section-content">
                <span>{orderInfo.remark}</span>
              </div>
            </div>
          )}
          <div className="bottom-nav">
            <div className="txt-r">
              {orderInfo.status == 0 && (
                <React.Fragment>
                  <span className="btn" onClick={this.cancelOrder}>
                    取消订单
                  </span>
                  <span
                    className="btn btn-orange orderDetail-pay-directly"
                    onClick={this.payOrder}
                  >
                    立即支付
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 1 && (
                <React.Fragment>
                  <span className="btn" onClick={this.verificationCode}>
                    核销码
                  </span>
                  {!orderInfo.timeDiff && (
                    <span className="btn" onClick={this.applyDrawback}>
                      申请退款
                    </span>
                  )}
                </React.Fragment>
              )}
              {orderInfo.status == 2 && (
                <React.Fragment>
                  <span className="btn" onClick={this.verificationCode}>
                    核销码
                  </span>
                  {!orderInfo.timeDiff && (
                    <span className="btn" onClick={this.applyDrawback}>
                      申请退款
                    </span>
                  )}
                  <span className="btn btn-orange" onClick={this.sureReceipt}>
                    确认消费
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 3 && (
                <React.Fragment>
                  <span className="btn" onClick={this.orderDelete}>
                    刪除订单
                  </span>
                  <span className="btn btn-orange" onClick={this.makeComment}>
                    去评价
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 4 && (
                <React.Fragment>
                  <span>退款审核中</span>
                </React.Fragment>
              )}
              {orderInfo.status == 5 && (
                <React.Fragment>
                  <span className="btn" onClick={this.receiveDrawback}>
                    收到退款
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 6 && (
                <React.Fragment>
                  <span className="btn" onClick={this.verificationCode}>
                    核销码
                  </span>
                  <span className="btn" onClick={this.orderDelete}>
                    刪除订单
                  </span>
                </React.Fragment>
              )}
              {orderInfo.status == 7 && (
                <React.Fragment>
                  <span className="btn" onClick={this.orderDelete}>
                    刪除订单
                  </span>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/appointment-order-detail/AppointmentOrderDetail.jsx